"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _asyncIterator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncIterator"));

var _dataModel = require("@rdfjs/data-model");

var _promiseUtils = require("./promiseUtils");
/**
 * Returns a function that, when called with arguments,
 * extends the path with mutationExpressions.
 *
 * It uses the current path expression as domain expression
 * and the given arguments as range expression.
 * These arguments can either be raw, or other path expressions.
 *
 * Requires:
 * - a pathExpression property on the path proxy and all non-raw arguments.
 */


var MutationFunctionHandler =
/*#__PURE__*/
function () {
  function MutationFunctionHandler(mutationType, allowZeroArgs) {
    _classCallCheck(this, MutationFunctionHandler);

    this._mutationType = mutationType;
    this._allowZeroArgs = allowZeroArgs;
  }

  _createClass(MutationFunctionHandler, [{
    key: "handle",
    value: function handle(pathData, path) {
      var _this = this;

      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        // Check if the given arguments are valid
        if (!_this._allowZeroArgs && !args.length) throw new Error("Mutation on ".concat(pathData, " can not be invoked without arguments")); // Create a lazy Promise to the mutation expressions

        var then = (0, _promiseUtils.getThen)(function () {
          return _this.createMutationExpressions(pathData, path, args);
        });
        return pathData.extendPath({
          mutationExpressions: {
            then: then
          }
        });
      };
    }
  }, {
    key: "createMutationExpressions",
    value: function () {
      var _createMutationExpressions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pathData, path, args) {
        var conditions, objects, mutationType, _conditions$pop, predicate;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return path.pathExpression;

              case 2:
                conditions = _context.sent;

                if (Array.isArray(conditions)) {
                  _context.next = 5;
                  break;
                }

                throw new Error("".concat(pathData, " has no pathExpression property"));

              case 5:
                if (!(conditions.length < 2)) {
                  _context.next = 7;
                  break;
                }

                throw new Error("".concat(pathData, " should at least contain a subject and a predicate"));

              case 7:
                _context.next = 9;
                return this.extractObjects(pathData, path, args);

              case 9:
                objects = _context.sent;
                // If no objects were specified, mutate all objects in the domain
                mutationType = this._mutationType;

                if (objects) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", [{
                  mutationType: mutationType,
                  conditions: conditions
                }]);

              case 13:
                if (!(objects.length === 0)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", []);

              case 15:
                // Otherwise, mutate the affected objects
                _conditions$pop = conditions.pop(), predicate = _conditions$pop.predicate;

                if (predicate) {
                  _context.next = 18;
                  break;
                }

                throw new Error("Expected predicate in ".concat(pathData));

              case 18:
                return _context.abrupt("return", [{
                  mutationType: mutationType,
                  conditions: conditions,
                  predicate: predicate,
                  objects: objects
                }]);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createMutationExpressions(_x, _x2, _x3) {
        return _createMutationExpressions.apply(this, arguments);
      }

      return createMutationExpressions;
    }()
  }, {
    key: "extractObjects",
    value: function () {
      var _extractObjects = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pathData, path, args) {
        var objects, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, arg, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(args.length === 0)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", null);

              case 2:
                // Expand strings, promises, and paths
                objects = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 6;
                _iterator2 = args[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 58;
                  break;
                }

                arg = _step2.value;

                if (!(arg && arg[Symbol.asyncIterator])) {
                  _context2.next = 46;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 13;
                _iterator = (0, _asyncIterator2.default)(arg);

              case 15:
                _context2.next = 17;
                return _iterator.next();

              case 17:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 21;
                return _step.value;

              case 21:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 28;
                  break;
                }

                item = _value;
                objects.push(this.extractObject(pathData, path, item));

              case 25:
                _iteratorNormalCompletion = true;
                _context2.next = 15;
                break;

              case 28:
                _context2.next = 34;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t0 = _context2["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 34:
                _context2.prev = 34;
                _context2.prev = 35;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 39;
                  break;
                }

                _context2.next = 39;
                return _iterator.return();

              case 39:
                _context2.prev = 39;

                if (!_didIteratorError) {
                  _context2.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context2.finish(39);

              case 43:
                return _context2.finish(34);

              case 44:
                _context2.next = 55;
                break;

              case 46:
                _context2.t1 = objects;
                _context2.t2 = this;
                _context2.t3 = pathData;
                _context2.t4 = path;
                _context2.next = 52;
                return arg;

              case 52:
                _context2.t5 = _context2.sent;
                _context2.t6 = _context2.t2.extractObject.call(_context2.t2, _context2.t3, _context2.t4, _context2.t5);

                _context2.t1.push.call(_context2.t1, _context2.t6);

              case 55:
                _iteratorNormalCompletion2 = true;
                _context2.next = 8;
                break;

              case 58:
                _context2.next = 64;
                break;

              case 60:
                _context2.prev = 60;
                _context2.t7 = _context2["catch"](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t7;

              case 64:
                _context2.prev = 64;
                _context2.prev = 65;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 67:
                _context2.prev = 67;

                if (!_didIteratorError2) {
                  _context2.next = 70;
                  break;
                }

                throw _iteratorError2;

              case 70:
                return _context2.finish(67);

              case 71:
                return _context2.finish(64);

              case 72:
                return _context2.abrupt("return", objects);

              case 73:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 60, 64, 72], [13, 30, 34, 44], [35,, 39, 43], [65,, 67, 71]]);
      }));

      function extractObjects(_x4, _x5, _x6) {
        return _extractObjects.apply(this, arguments);
      }

      return extractObjects;
    }()
  }, {
    key: "extractObject",
    value: function extractObject(pathData, path, arg) {
      if (typeof arg === 'string') return (0, _dataModel.literal)(arg);
      if (arg && arg.termType) return arg;
      throw new Error("Invalid object: ".concat(arg));
    }
  }]);

  return MutationFunctionHandler;
}();

exports.default = MutationFunctionHandler;